export default __webpack_public_path__ + "static/media/logo-with-text.c63c7c8d.png";